/* Loxhaven product bundle codes. The server is authoritative for every total. */
(function () {
  'use strict';
  const config = window.LoxhavenBundleConfig;
  if (!config || !config.enabled || !Array.isArray(config.rules) || window.LoxhavenBundles) return;
  const nativeFetch = window.fetch.bind(window);
  const managedCodes = new Set(config.rules.map(rule => rule.code.toUpperCase()));
  const rulesByProduct = new Map();
  config.rules.forEach(rule => {
    const id = String(rule.productId).split('/').pop();
    const rules = rulesByProduct.get(id) || [];
    rules.push(rule);
    rulesByProduct.set(id, rules.sort((a, b) => a.minimumQuantity - b.minimumQuantity));
  });
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let queue = Promise.resolve();
  let mutationQueue = Promise.resolve();
  let lastError = '';
  let lastCart = null;
  let bypassCheckout = false;
  let checkoutBusy = false;
  let mutationCount = 0;
  const pendingMutations = new Set();

  function selection(cart, appliedCodes) {
    const quantities = new Map();
    for (const item of cart.items || []) {
      const id = String(item.product_id);
      quantities.set(id, (quantities.get(id) || 0) + item.quantity);
    }
    const selected = [];
    for (const [id, quantity] of quantities) {
      const eligible = (rulesByProduct.get(id) || []).filter(rule => quantity >= rule.minimumQuantity);
      if (eligible.length) selected.push(eligible[eligible.length - 1]);
    }
    const existing = appliedCodes || [];
    const external = existing.filter(item => !managedCodes.has(item.code.toUpperCase()));
    return {selected, external, codes: [...external.map(item => item.code), ...selected.map(rule => rule.code)]};
  }

  function message(error) {
    lastError = error || '';
    let node = document.getElementById('LoxhavenBundleMessage');
    if (!error) { if (node) node.remove(); return; }
    if (!document.body) return;
    if (!node) {
      node = document.createElement('div');
      node.id = 'LoxhavenBundleMessage';
      node.setAttribute('role', 'alert');
      node.style.cssText = 'position:fixed;z-index:2147483000;bottom:18px;left:50%;transform:translateX(-50%);width:min(92vw,540px);padding:16px 20px;background:#fff3e8;border:1px solid #9e5930;border-radius:8px;color:#40210f;font:14px/1.5 sans-serif;box-shadow:0 4px 20px #0002';
      document.body.appendChild(node);
    }
    node.textContent = error;
  }

  function sections() {
    const ids = new Set(['loxhaven-cart-state', 'cart-drawer', 'cart-icon-bubble']);
    document.querySelectorAll('[data-id]').forEach(node => {
      if (/cart-items|cart-footer/.test(node.id || '')) ids.add(node.dataset.id);
    });
    return [...ids].slice(0, 5);
  }

  async function cartRequest(path, options) {
    const response = await nativeFetch(root + path, Object.assign({credentials: 'same-origin', cache: 'no-store'}, options));
    if (!response.ok) throw new Error('We could not check your bundle offer. Please try again before checking out.');
    return response.json();
  }

  function readCarrier(markup) {
    if (!markup) return null;
    const doc = new DOMParser().parseFromString(markup, 'text/html');
    const node = doc.querySelector('[data-loxhaven-cart-state]');
    if (!node) return null;
    return {cart: JSON.parse(node.getAttribute('data-cart')), codes: JSON.parse(node.getAttribute('data-codes'))};
  }

  async function cartState() {
    const data = await cartRequest('?sections=loxhaven-cart-state');
    const state = readCarrier(data['loxhaven-cart-state']);
    if (!state) throw new Error('We could not check your cart. Please refresh the page before checking out.');
    return state;
  }

  async function synchronize() {
    let state = await cartState();
    let cart = state.cart;
    if (cart.currency !== config.currency) throw new Error('Bundle offers are currently available in ' + config.currency + '. Please switch currency or contact us before checking out.');
    const plan = selection(cart, state.codes);
    const productCodeCount = plan.selected.length + plan.external.filter(item => item.targetType !== 'shipping_line').length;
    if (productCodeCount > (config.maxCodes || 5)) {
      throw new Error('This cart includes more bundle offers or discount codes than checkout supports. Please split it into two orders or remove another discount code.');
    }
    const requested = plan.codes.map(code => code.toUpperCase()).sort().join(',');
    const applied = state.codes.map(item => item.code.toUpperCase()).sort().join(',');
    if (requested !== applied) {
      cart = await cartRequest('cart/update.js', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({discount: plan.codes.join(','), sections: sections(), sections_url: location.pathname})
      });
      state = readCarrier(cart.sections && cart.sections['loxhaven-cart-state']) || await cartState();
    }
    const actual = state.cart;
    for (const rule of plan.selected) {
      const items = (actual.items || []).filter(item => String(item.product_id) === String(rule.productId).split('/').pop());
      const quantity = items.reduce((sum, item) => sum + item.quantity, 0);
      if (items.some(item => item.original_price !== rule.unitPriceCents)) throw new Error('The product price has changed. Please refresh the page before checking out.');
      const actualTotal = items.reduce((sum, item) => sum + item.final_line_price, 0);
      const expectedMaximum = quantity * rule.unitPriceCents - rule.fixedOffCents;
      if (actualTotal > expectedMaximum) throw new Error('Your bundle offer could not be applied with the current cart or discount code. Please review the cart before checking out.');
    }
    lastCart = cart;
    message('');
    document.dispatchEvent(new CustomEvent('loxhaven:bundles-ready', {detail: {cart}}));
    return cart;
  }

  function enqueue() {
    const task = queue.catch(() => {}).then(synchronize).catch(error => {
      message(error.message);
      throw error;
    });
    queue = task;
    return task;
  }

  function renderSections(cart) {
    Object.entries(cart.sections || {}).forEach(([id, markup]) => {
      if (id === 'loxhaven-cart-state' || !markup) return;
      const doc = new DOMParser().parseFromString(markup, 'text/html');
      const current = document.getElementById('shopify-section-' + id) || document.getElementById(id);
      if (!current) return;
      const replacement = doc.getElementById(current.id);
      if (replacement) current.innerHTML = replacement.innerHTML;
    });
  }

  window.fetch = function (input, options) {
    let url;
    try { url = new URL(typeof input === 'string' ? input : input.url, location.origin); }
    catch (_) { return nativeFetch(input, options); }
    if (url.origin !== location.origin || !/\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname)) return nativeFetch(input, options);
    mutationCount += 1;
    const mutation = mutationQueue.catch(() => {}).then(() => nativeFetch(input, options)).then(async response => {
      if (!response.ok) return response;
      let original;
      try { original = await response.clone().json(); } catch (_) { return response; }
      const cart = await enqueue();
      const body = /\/add(?:\.js)?$/.test(url.pathname) ? Object.assign({}, original, cart.sections ? {sections: cart.sections} : {}) : Object.assign({}, original, cart);
      const headers = new Headers(response.headers);
      headers.delete('content-length'); headers.delete('content-encoding');
      headers.set('content-type', 'application/json');
      return new Response(JSON.stringify(body), {status: response.status, statusText: response.statusText, headers});
    }).finally(() => { pendingMutations.delete(mutation); mutationCount -= 1; });
    mutationQueue = mutation;
    pendingMutations.add(mutation);
    return mutation;
  };

  async function beforeCheckout(resume) {
    if (checkoutBusy) return;
    checkoutBusy = true;
    try {
      while (pendingMutations.size) await Promise.all([...pendingMutations]);
      await enqueue();
      bypassCheckout = true;
      resume();
    } catch (_) { /* Error is displayed by enqueue; checkout waits for a valid total. */ }
    finally { checkoutBusy = false; }
  }

  document.addEventListener('click', event => {
    const target = event.target.closest && event.target.closest('button[name="checkout"],input[name="checkout"],a[href^="/checkout"],a[href*="/checkouts/"]');
    if (!target) return;
    if (bypassCheckout) { setTimeout(() => { bypassCheckout = false; }, 0); return; }
    event.preventDefault(); event.stopImmediatePropagation();
    beforeCheckout(() => target.click());
  }, true);
  document.addEventListener('submit', event => {
    const submitter = event.submitter;
    if (!(submitter && submitter.name === 'checkout') && !/\/checkout(?:\/|$)/.test(event.target.action || '')) return;
    if (bypassCheckout) { bypassCheckout = false; return; }
    event.preventDefault(); event.stopImmediatePropagation();
    beforeCheckout(() => { bypassCheckout = true; event.target.requestSubmit(submitter || undefined); });
  }, true);

  window.LoxhavenBundles = {sync: enqueue, selection, status: () => ({error: lastError, pending: mutationCount, cart: lastCart})};
  document.addEventListener('DOMContentLoaded', () => {
    enqueue().then(renderSections).catch(() => {});
  }, {once: true});
})();
